import { logUsage } from 'owa-analytics';
import loc from 'owa-localize';
import { SearchPlaceholder } from 'owa-locstrings/lib/strings/searchplaceholder.locstring.json';
import { SearchScenarioId } from 'owa-search-next-common';
import * as React from 'react';

const classNames = require('classnames');
const styles = require('./SearchInput.scss');

export interface ISearchInput {
    setFocus(): void;
    searchInputText: string;
    activeDescendant: string;
}

export interface SearchInputProps {
    searchPlaceHolderText?: string;
    isDisabled?: boolean; // Boolean indicating if search box is disabled (default is false)
    scenarioId: SearchScenarioId;
    isSuggestionsCalloutVisible: boolean;
    isUsing3S: boolean;
}

export default function SearchInputLoading(props: SearchInputProps): JSX.Element {
    const { isDisabled } = props;

    const searchInputClasses = classNames(
        styles.searchBoxInput,
        isDisabled && styles.isDisabled,
        styles.inputPlaceholder
    );

    const onClick = React.useCallback(() => {
        logUsage('Search_PlaceholderSearchBoxClicked');
    }, []);

    return (
        <div className={styles.searchBoxInputContainer} onClick={onClick}>
            <input
                className={searchInputClasses}
                disabled={true}
                placeholder={loc(SearchPlaceholder)}
            />
        </div>
    );
}
